import { render, staticRenderFns } from "./PlainGrid.vue?vue&type=template&id=edff86aa&scoped=true&"
import script from "./PlainGrid.vue?vue&type=script&lang=js&"
export * from "./PlainGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edff86aa",
  null
  
)

export default component.exports